import { apiDebug } from '../utils/apiDebug';
import { getApiBaseUrl } from '../config/apiConfig';

/**
 * API service for positions
 */
class PositionsApi {
  /**
   * Get all public positions (active only)
   * @param {Object} params - Query parameters
   * @returns {Promise<Object>} Response with positions data
   */
  static async getPublicPositions(params = {}) {
    const queryParams = new URLSearchParams();
    
    if (params.type) queryParams.append('type', params.type);
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.offset) queryParams.append('offset', params.offset);

    const url = `${getApiBaseUrl()}/api/website/positions/public?${queryParams.toString()}`;
    
    try {
      apiDebug.logRequest('GET', url, params);
      
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      apiDebug.logResponse('GET', url, data, response.status);
      return data;
    } catch (error) {
      apiDebug.logError('GET', url, error);
      console.error('Error fetching public positions:', error);
      throw error;
    }
  }

  /**
   * Get a specific position by ID
   * @param {string} id - Position ID
   * @returns {Promise<Object>} Response with position data
   */
  static async getPositionById(id) {
    const url = `${getApiBaseUrl()}/api/website/positions/public/${id}`;
    
    try {
      apiDebug.logRequest('GET', url);
      
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      apiDebug.logResponse('GET', url, data, response.status);
      return data;
    } catch (error) {
      apiDebug.logError('GET', url, error);
      console.error('Error fetching position by ID:', error);
      throw error;
    }
  }
}

export default PositionsApi; 